<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Solicitudes de transferencia de Personal</legend>
          </div>

          <div v-if="!add_item">
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-6">
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">

                    <v-data-table :headers="headers" :items="list_usuarios" :expanded.sync="expanded" :search="filter"  :single-expand="singleExpand" >
                    <template v-slot:item="{item, expand, isExpanded }">
                  <tr>
                      <td>
                        <b-button @click="expand(!isExpanded)" class="btn-s edit mr-2" variant="primary"><i class="fas fa-search"></i></b-button>
                      </td>
                      <td> {{ item.updated_at }} </td>
                      <td> {{ item.rfc }} </td>
                      <td> {{ item.nombre }} </td>
                  </tr>
                  </template>
                  <template v-slot:expanded-item="{ headers, item}">
                    <td :colspan="headers.length">
                      <div class="row p-4">
                      <div class=" col-12">
                        <div class="card ">
                          <div class="card-body">
                            <p class="m-0">
                              <strong> Cambio solicitado por </strong>: {{item.usuario.Nombre+' '+item.usuario.Paterno+' '+item.usuario.Materno}}
                            </p>
                            <p class="m-0">
                              <strong> Cambio </strong>: {{getStatus(item.status)}}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card">
                          <div class="card-body">
                            <h5 class="card-title">Datos Actuales</h5>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item" v-for="(value, key) in item.datos_actuales" :key="key"><strong>{{ key.replace("_", " ") }}</strong> : {{returnValueKey(value,key)}}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card">
                          <div class="card-body">
                            <h5 class="card-title">Datos de Transferencia</h5>
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item" v-for="(value, key) in item.datos_cambio" :key="key"><strong>{{  key.replace("_", " ") }}</strong> : {{returnValueKey(value,key)}}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                      <div class="row justify-content-end m-3">
                        <button class="btn btn-success" @click.prevent="validar(item)">
                          <span>
                            <i class="fa fa-check"></i> Validar
                          </span>
                        </button>

                        <button class="btn btn-danger ml-3" @click.prevent="rechazar(item)">
                          <span>
                            <i class="fa fa-times"></i> Rechazar
                          </span>
                        </button>
                      </div>
                    </div>

                    </div>

                    </td>
                  </template>
                </v-data-table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import moment from 'moment'
  import {
    Select,
    Option,
    DatePicker
  } from "element-ui";

  import {
    mapFields
  } from "vee-validate";


  Vue.use(Select);
  Vue.use(Option);
  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    props: ["data"],
    data() {
      return {
        movimiento:{},
        options: [{
            id: 1,
            label: "foo"
          },
          {
            id: 3,
            label: "bar"
          },
          {
            id: 2,
            label: "baz"
          }
        ],
        currentPage: 1,
        perPage: 50,
        rows: null, //Aquí lo puse null
        rol: "",
        filter: null,
        id: 1,
        add_item: false,
        edit_item: null,
        tipos: null,
        dependencias: null,
        usuarios: null,
        item_usuarios: {},
        list_usuarios: [],
        expanded: [],
        singleExpand: true,
        headers: [{
            text: 'Acciones',
            value: 'acciones',
            align: 'center',
          }, {
            text: 'Fecha',
            value: 'updated_at ',
            align: 'center',
          },
          /* {
                   text: 'Dependencia',
                   value: 'ente',
                   align: 'center',
                 },  */
          {
            text: 'RFC',
            value: 'rfc',
            align: 'center',
          }, {
            text: 'Nombre',
            value: 'nombre',
            align: 'center',
          }
        ],
        fields_list: [{
            key: "acciones",
            label: "Acciones",
            thClass: "td-small",
            tdClass: "text-center td-small"
          },
          {
            key: "updated_at",
            label: "Fecha",
            thClass: "td-medium",
            tdClass: "text-center td-medium",
            formatter: value => {
              if(value)
                return moment(String(value)).format('DD/MM/YYYY')
              else
                return ''
            }
          },
          {
            key: "rfc",
            label: "RFC",
            thClass: "td-medium",
            tdClass: "text-center td-medium",
            formatter: "emptyFields"
          },
          {
            key: "nombre",
            label: "Nombre",
            tdClass: "text-left",
            formatter: "emptyFields"
          }
        ]
      };
    },
    computed: {
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        this.rows = this.list_usuarios.length;
        return this.list_usuarios.length;
      },
      fullName: {
        get() {
          return `${this.item_usuarios.nombres} ${
          this.item_usuarios.primer_apellido
        } ${this.item_usuarios.segundo_apellido}`;
        },
        set(newValue) {
          const m = newValue.match(/(\S*)\s+(.*)/);

          this.nombres = m[1];
          this.primer_apellido = m[2];
          this.segundo_apellido = m[3];
        }
      }
    },
    methods: {
      formato(fecha){
        return moment(String(value)).format('DD/MM/YYYY')
      },
      returnValueKey(v, k) {
        return v
      },
      initItem() {
        this.item_usuarios = {
          acciones: "",
          nombres: "",
          Paterno: "",
          Materno: "",
          User: "",
          Password: ""
        };
      },
      showItem() {
        this.add_item = !this.add_item;
      },
      cancelEdit() {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        }
        this.initItem();
        this.showItem();
        this.edit_item = null;
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      getDependencias(index) {
        var resp = " ";
        if (this.dependencias) {
          this.dependencias.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      validar(item){
        this.Ask("¿Deseas aplicar los cambios?", () => {
          //            this.$http.get("solicitudes/aprobar/"+item.item.id).then(

            this.$http.get("solicitudes/aprobar/"+item.id).then(
              response => {
                this.StepOk("Transferencia aprobada")
                this.getSolicitudes()
                this.expanded =[];
              },
              error => {
                this.StepError(error);
              }
            );
        })
      },
      rechazar(item){
        this.Ask("¿Deseas rechazar los cambios?", () => {

            //this.$http.get("solicitudes/rechazar/"+item.item.id).then(
              this.$http.get("solicitudes/rechazar/"+item.id).then(
              response => {
                this.StepOk("Transferencia rechazada")
                this.getSolicitudes()
                 this.expanded =[];
              },
              error => {
                this.StepError(error);
              }
            );
        })

      },
      getStatus(status) {
        if (status === 0) {
            return "Solicitado";
        }if (status === 2) {
            return "Aprobado";
        }
        else{
            return "Rechazado"
        }
      },
      getSolicitudes(){

      this.$http.get("getSolicitudes").then(
        response => {
          var v = this;
          this.list_usuarios=[];
          $.each(response.data.solicitudes, function(key, value) {
              let dependencia_destino ='Sin Datos'
              if(value.dependencia_destino)
                dependencia_destino = value.dependencia_destino.valor
               v.list_usuarios.push({
                 'updated_at': value.updated_at,
                 'rfc':value.datos_actuales.rfc,
                 'id':value.id,
                 'status':value.status,
                 'usuario':value.usuario,
                 'nombre': value.datos_actuales.nombres +' '+value.datos_actuales.primer_apellido+' '+value.datos_actuales.segundo_apellido,
                 'datos_actuales':{
                    'dependencia': value.dependencia_origen.valor,
                    'rfc': value.datos_actuales.rfc,
                    'curp': value.datos_actuales.curp,
                    'nombres': value.datos_actuales.nombres,
                    'primer_apellido': value.datos_actuales.primer_apellido,
                    'segundo_apellido': value.datos_actuales.segundo_apellido,
                    'area_adscripcion': value.datos_actuales.area_adscripcion,
                    'correo_laboral': value.datos_actuales.correo_laboral,
                    'cargo': value.datos_actuales.empleo_cargo_comision,
                    'toma_posesion': value.datos_actuales.fecha_posesion,
                    'nivel_encargo': value.datos_actuales.nivel_encargo
                 },
                 'datos_cambio':{
                    'dependencia': dependencia_destino,
                    'rfc': value.datos_cambio.rfc,
                    'curp': value.datos_cambio.curp,
                    'nombres': value.datos_cambio.nombres,
                    'primer_apellido': value.datos_cambio.primer_apellido,
                    'segundo_apellido': value.datos_cambio.segundo_apellido,
                    'area_adscripcion': value.datos_cambio.area_adscripcion,
                    'correo_laboral': value.datos_cambio.correo_laboral,
                    'cargo': value.datos_cambio.empleo_cargo_comision,
                    'toma_posesion': value.datos_cambio.fecha_posesion,
                    'nivel_encargo': value.datos_cambio.nivel_encargo

                 }
               })
          })

        },
        error => {
          this.Err(error);
        }
      );

      }
    },
    created() {
      this.initItem();
      this.getSolicitudes()

    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/Transferencias.vue